import {
    Box,
    FormControlLabel,
    IconButton,
    InputAdornment,
    MenuItem,
    Switch,
    TextField,
    Tooltip,
} from "@material-ui/core";
import { GetApp as GetAppIcon } from "components/MaterialSymbol/MaterialIcons";
import { Search as SearchIcon } from "components/MaterialSymbol/MaterialIcons";
import { Save as SaveIcon } from "components/MaterialSymbol/MaterialIcons";
import PageLayout from "layouts/PageLayout";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import TextFileReaderUploader from "components/TextFileReaderUploader/TextFileReaderUploader";
import useBulkItems from "hooks/useBulkItems";
import useDealerCatalogs from "hooks/useDealerCatalogs";
import BulkTable from "./BulkTable";
import CustomButton from "components/CustomButtons/Button.js";

export default function BulkEditItem() {
    const {
        catalogName,
        setCatalogName,
        mustValidate,
        setMustValidate,
        products = [],
        setProducts,
        productsEditedParts = [],
        handleCSVUpload,
        handlePartNumberChange,
        handleClickDelete,
        partNumberFilter,
        setPartNumberFilter,
        handleDownloadCSV,
        handleApplyChanges,
    } = useBulkItems();
    const dealerCatalogs = useDealerCatalogs();

    const filteredProducts =
        partNumberFilter.length > 0
            ? products.filter((p) =>
                  p.partNumber.toLowerCase().includes(partNumberFilter.toLowerCase())
              )
            : products;

    return (
        <PageLayout>
            <GridContainer className="bulk-items-toolbar">
                <GridItem xs={12} sm={12} md={4}>
                    <TextField
                        size="small"
                        label="Type part number"
                        variant="outlined"
                        fullWidth
                        value={partNumberFilter}
                        onChange={(e) => setPartNumberFilter(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title="Search">
                                        <SearchIcon fontSize="small" />
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        }}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={8}>
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        alignItems="center"
                        justifyContent="flex-end"
                        gridGap={12}
                    >
                        <FormControlLabel
                            style={{ margin: 0 }}
                            control={
                                <Switch
                                    checked={mustValidate}
                                    onChange={(e) => {
                                        setMustValidate(e.target.checked);
                                    }}
                                    name="checkedB"
                                    color="primary"
                                />
                            }
                            label="Must validate?"
                        />
                        <TextField
                            select
                            label="Catalog"
                            value={catalogName}
                            onChange={(e) => {
                                setCatalogName(e.target.value);
                            }}
                            variant="outlined"
                            size="small"
                            style={{ minWidth: 180 }}
                        >
                            {dealerCatalogs.map((option) => (
                                <MenuItem key={option.catalogName} value={option.catalogName}>
                                    {option.enDisplayName}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextFileReaderUploader
                            disabled={catalogName === ""}
                            accept=".csv"
                            onUpload={handleCSVUpload}
                        />
                        <Tooltip title="Download CSV file sample">
                            <a href="/bulk_template.csv" download="bulk_template.csv">
                                <IconButton aria-label="Download sample CSV">
                                    <GetAppIcon fontSize="small" />
                                </IconButton>
                            </a>
                        </Tooltip>
                        <Tooltip title="Download CSV file existing rules">
                            <IconButton
                                aria-label="Download existing rules CSV"
                                onClick={handleDownloadCSV}
                            >
                                <GetAppIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </GridItem>
            </GridContainer>
            <Box mt={2.5}>
                <BulkTable
                    products={filteredProducts}
                    setProducts={setProducts}
                    onDeleteClick={handleClickDelete}
                    onPartNumberChange={handlePartNumberChange}
                />
            </Box>
            {/* x */}
            <Box textAlign="center" mt={2.5}>
                <CustomButton type="button" color="rose" onClick={handleApplyChanges}>
                    Apply changes
                </CustomButton>
            </Box>
        </PageLayout>
    );
}
